namespace Areas.Maintenance.DailyReportTemplate {
    "use strict";

    let dailyReportTemplateId: number;
    let templateText: any;
   
    export function getdailyReportTemplateId() {
        return dailyReportTemplateId;
    }

    export function onNewTemplate(e: any) {
        templateText = e.data;
        const parameters = { templateId: 0, postOrPut: "post" };
        const templateTextDialog = new Areas.Dialogs.TemplateText.TemplateTextDialog(dialogClosing, parameters)
    }

    export function onEditTemplate(e: any) {
        templateText = e.data;
        const parameters = { templateId:templateText.dailyReportTemplateId, templateTitle: templateText.templateTitle, reportNotesTemplate: templateText.reportNotesTemplate, postOrPut:"put" };
        const templateTextTialog = new Areas.Dialogs.TemplateText.TemplateTextDialog(
                dialogClosing, parameters); 
    }

 
    function dialogClosing(dialogResult: DialogResult, data: any) {

        const dataGrid: any = $("#DailyReportTemplateGrid").dxDataGrid("instance");
        Areas.refreshGrid("DailyReportTemplateGrid");

    }

}
